module.exports = __webpack_public_path__ + "fontawesome-webfont.c4668ed2440df82d3fd2.ttf";


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/assets/font-awesome/fonts/fontawesome-webfont.ttf?v=4.2.0
// module id = ../../../../../src/assets/font-awesome/fonts/fontawesome-webfont.ttf?v=4.2.0
// module chunks = 2